import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Login = _resolveComponent("Login");
  return _openBlock(), _createElementBlock("div", null, [$setup.sdkRendering ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Login, {
    show: $setup.showSdk,
    onClose: $setup.onClose,
    onFinish: $setup.onFinish,
    autoDownConfig: $setup.autoDownConfig,
    clientId: $setup.clientId
  }, null, 8, ["show", "onClose", "onFinish", "autoDownConfig", "clientId"])])) : _createCommentVNode("", true)]);
}